import { Auth } from "aws-amplify";

export default async ({ email }) => Auth.forgotPassword(email);
